export const pipelines = {
  methods: {
    clearDots(dots) {
      var arr = [];
      var i = 0;
      for (var dot of dots) {
        if (!dot.deleted && dot.x && dot.y) {
          arr[i] = {};
          arr[i].x = dot.x;
          arr[i].y = dot.y;
          if (dot.valve) {
            arr[i].valve = dot.valve;
          }
          if (dot.dots) {
            var childDots = this.clearDots(dot.dots);
            if (childDots || childDots.length > 0) {
              arr[i].dots = childDots;
            }
          }
          i++;
        }
      }
      return arr;
    },
    pipelineNewPos(pipeline) {
      if (pipeline.autoL == 1) {
        pipeline.L = this.getPipelineLength(pipeline.dots, this.substrate.k);
      }
      var data = pipeline;
      data.dots = this.clearDots(data.dots);
      if (!data.dots || data.dots.length == 1) {
        return false;
      }
      this.$http
        .post("risk/pipeline/pipeline-update-cords?proj_id=" + this.id + "&id=" + data.id, {
          dots: data.dots,
        })
        .then((response) => {
          if (response.data.Pot_rs_graf) {
            this.$set(data, "Pot_rs_graf", response.data.Pot_rs_graf);
            this.$set(data, "edit", false);
          } else {
            this.$set(data, "newPose", true);
            this.$emit("clearCalculations");
          }
          // JSON responses are automatically parsed.
        })
        .catch((e) => {
          console.error(e);
        });
    },
    pipelineAdd() {
      this.newPipeline = { dots: {} };
      Object.assign(this.newPipeline, this.temp);

      this.$set(this.newPipeline, "dots", [
        {
          x: this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].lat,
          y: this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].lng,
        },
        { x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y },
      ]);
      this.$emit("update:action", "pipelineAddLine");
    },
    pipelineAddLine() {
      this.newPipeline.dots.push({ x: this.getScaledPointerPosition().x, y: this.getScaledPointerPosition().y });
    },
    pipelineFinish() {
      if (this.action == "pipelineAddLine") {
        this.$emit("update:action", "do_nothing");
        this.$nextTick(() => {
          this.newPipeline.dots.splice(-1, 1);
        });
      }
      if (this.newPipeline.unconnected == true) {
        this.$emit("showPipelineNewWindow", this.newPipeline);
        return true;
      }
      this.newPipeline.parentDots = {
        x: this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].lat,
        y: this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].lng,
      };
      this.$bvModal.show("pipelineConnect");
    },

    pipelineUnconnectedSave() {
      this.$http
        .post("risk/pipeline/unconnected-to-map?proj_id=" + this.temp.proj_id, this.newPipeline)
        .then((response) => {
          if (!this.installations[this.newPipeline.index].mapPipelines) {
            this.$set(this.installations[this.newPipeline.index], "mapPipelines", []);
          }
          this.installations[this.newPipeline.index].mapPipelines.push(response.data);
          this.$set(this, "newPipeline", null);
          this.$emit("update:temp", {});
          this.oldData = true;
        })
        .catch((e) => {
          console.error(e);
          alert("Возникла ошибка");
        });
      return true;
    },
  },
};
